export default "__VITE_ASSET__0eL2n3iv__"